import { sva } from "@agapi/ui/panda/css";

export const stepContainerStyles = sva({
  slots: ['root', 'container', 'arrow'],
  base: {
    root: {
      gap: 'snug',
      flexDir: 'column',
      paddingInline: '!0',
      position: 'static'
    },
    container: {
      display: 'flex',
      flexDir: 'row',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'static'
    },
    arrow: {
      position: 'absolute',
      bottom: '-40px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '80px',
      height: '40px',
      borderLeft: '60px solid transparent',
      borderRight: '60px solid transparent',
      borderTop: '60px solid white',
      zIndex: '1',
    }
  }
})
